module.exports = __webpack_public_path__ + "static/media/logomark-blue.89af9c42.svg";